import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import { EventTypeId } from '@ps/web-sports-enums';
import React from 'react';

import type { TennisMatch } from '@swf/generated/graphql/scoreboards/schemas';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  match?: TennisMatch;
}

const TennisScoreboard = ({ enrichedParticipants, match }: Props) => {
  const [participantA, participantB] = enrichedParticipants ?? [];
  const currentSet = match?.currentSet;
  const currentGame = currentSet?.currentGame;
  const currentServingParticipant = currentGame?.teamServing;

  return (
    <Scoreboard variant="lite">
      <ScoreboardParticipants>
        <ScoreboardParticipant
          name={participantA.participant}
          hasReservedMarkerSpace
          isVisibleMarker={currentServingParticipant === participantA.type}
        />
        <ScoreboardParticipant
          name={participantB.participant}
          hasReservedMarkerSpace
          isVisibleMarker={currentServingParticipant === participantB.type}
        />
      </ScoreboardParticipants>
      <ScoreboardScores>
        <ScoreboardScore score={[match?.teamAScore ?? null, match?.teamBScore ?? null]} />
        <ScoreboardScore score={[currentSet?.teamAScore ?? null, currentSet?.teamBScore ?? null]} />
        <ScoreboardScore
          score={[currentGame?.teamAScore ?? null, currentGame?.teamBScore ?? null]}
          scoreCharacterLength={getScoreCharacterLength(EventTypeId.TENNIS, [
            currentSet?.teamAScore ?? 0,
            currentSet?.teamBScore ?? 0
          ])}
        />
      </ScoreboardScores>
    </Scoreboard>
  );
};

export default TennisScoreboard;
